import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const optEmailCamera = (optEmailData) => async (dispatch) => {
    try {
        const { data } = await api.optEmailCamera(optEmailData);

        dispatch({
            type: Actions.OPT_EMAIL_CAMERA,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}